/* eslint-disable max-lines */
import {
    Divider,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    VStack,
} from '@chakra-ui/react';
import React, {
    ReactElement,
} from 'react';
import {
    Hide, Show, TabDropdown,
} from '../../components';

function TabSectionList({
    labels,
}: {
    labels: React.ReactNode[];
}) {
    return (
        <>
            <Show above="md">
                <TabList w="100%" gap={[0, null, 6, 8]}>
                    {labels.map((label, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Tab key={index}>{label}</Tab>
                    ))}
                </TabList>
                {}
                <Divider borderColor="muted.100" />
            </Show>

            <Hide above="md">
                <TabDropdown
                    items={labels.map((label) => label)}
                    w="full"
                    fontWeight="medium"
                    fontSize="sm"
                />
            </Hide>
        </>
    );
}

function TabSectionPanels({ children }: { children?: React.ReactNode }) {
    return (
        <TabPanels pt={6}>
            {children}
        </TabPanels>
    );
}

function TabSectionPanel({ children }: { children?: React.ReactNode }) {
    return (
        <TabPanel as={VStack} alignItems="stretch" p={0} pt={2} gap={4}>
            {children}
        </TabPanel>
    );
}

function TabLayout({ children }: { children?: React.ReactNode }) {
    return (
        <Tabs
            isLazy
            w="100%"
            variant="underline"
            colorScheme="primary"
            fontSize="md"
        >
            {/**
             * This little bit of nastiness lets us pick up components
             * from children and place them in different spots
             * based on their defined types
            */}
            {React.Children.toArray(children)
                .filter((child) => (child as ReactElement).type === TabSectionList)}
            {React.Children.toArray(children)
                .filter((child) => (child as ReactElement).type === TabSectionPanels)}
        </Tabs>
    );
}

function ControlledTabLayout({
    children,
    selectedTabIndex,
    onTabChange,
}: {
    children?: React.ReactNode;
    selectedTabIndex: number;
    onTabChange: (index: number) => void;
}) {
    return (
        <Tabs
            isLazy
            w="100%"
            index={selectedTabIndex}
            variant="underline"
            colorScheme="primary"
            fontSize="md"
            onChange={(idx) => onTabChange(idx)}
        >
            {/**
             * This little bit of nastiness lets us pick up components
             * from children and place them in different spots
             * based on their defined types
            */}
            {React.Children.toArray(children)
                .filter((child) => (child as ReactElement).type === TabSectionList)}
            {React.Children.toArray(children)
                .filter((child) => (child as ReactElement).type === TabSectionPanels)}
        </Tabs>
    );
}

TabLayout.List = TabSectionList;
TabLayout.Panels = TabSectionPanels;
TabLayout.Panel = TabSectionPanel;

export { TabLayout, ControlledTabLayout };
